import React from 'react';
import { scaleRotate as Menu } from 'react-burger-menu';
import styled from 'styled-components';

import NavLinks from '../shared/NavLinks';


const styles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '36px',
    height: '30px',
    left: '36px',
    top: '36px'
  },
  bmBurgerBars: {
    background: '#3d3b39'
  },
  bmCrossButton: {
    height: '24px',
    width: '24px'
  },
  bmCross: {
    background: '#fff'
  },
  bmMenu: {
    background: '#3d3b39',
    padding: '2.5em 1.5em 0',
    fontSize: '1.15em'
  },
  bmMorphShape: {
    fill: '#3d3b39'
  },
  bmItemList: {
    color: '#fff',
    padding: '0.8em',
    height: 'auto'
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)'
  }
};

const MobileNavLinkList = styled.ul`
  list-style: none;
  padding-left: 0;
`;

const MobileNavLinkListItem = styled.li``;

const MobileNavLink = styled.a`
  color: #fff;
  text-decoration: none;
  line-height: 1.9rem;
  border-left: 0px solid;
  padding-left: 0px;
  -webkit-transition: border-left 0.4s, padding-left 0.4s;
  transition: border-left 0.4s, padding-left 0.4s;
  cursor: pointer;

  &:hover{
    border-left: 3px solid;
    padding-left: 10px;
  }
`;

const MobileNav = ({ mobileNavOpen, updateMobileNavOpen }) => (
  <Menu
    isOpen={mobileNavOpen}
    styles={styles}
    customBurgerIcon={false}
    pageWrapId={'app-container'}
    onStateChange={updateMobileNavOpen}
  >
    <NavLinks
      NavLinkList={MobileNavLinkList}
      NavLinkListItem={MobileNavLinkListItem}
      NavLink={MobileNavLink}
      updateMobileNavOpen={updateMobileNavOpen}
    />
  </Menu>
  );

export default MobileNav;



// WEBPACK FOOTER //
// ./src/components/MobileNav.js